import * as React from 'react';
import { SVGProps } from 'react';

const IconAttachSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.434 3.294a1 1 0 0 0-1.414 0L4.505 8.81a2.5 2.5 0 0 0 3.535 3.535l4.597-4.596 1.414 1.414-4.596 4.596A4.5 4.5 0 1 1 3.09 7.396L8.606 1.88a3 3 0 1 1 4.243 4.243l-5.162 5.162L6.273 9.87l5.162-5.161a1 1 0 0 0 0-1.415z"
    />
  </svg>
);
export default IconAttachSizeS;
